import React from "react";
import {useTranslation} from "react-i18next";
import Notification, {NOTIFICATION_TYPE} from "../../../../../../../../../../../../common/notification";

type NotificationWarningProps = {
    code: string;
}

export const NotificationWarning = ({code}: NotificationWarningProps) => {

  const { t } = useTranslation()

  return <Notification
    sx={{ marginTop: 3 }}
    type={NOTIFICATION_TYPE.WARNING}
    title={`${t('dictionaries__text__certification__for')} ${code} ${t('dictionaries__text__certification__youHaventSelectedAnyCategories')}`}
    noCloseButton
  />
}
